import { useSelector } from "react-redux";
import { getStoreUrl } from "../../../../../../../state/modules/config/selectors";

const useLocalisedChildLinks = childLinks => {
  const storeUrl = useSelector(getStoreUrl);

  return childLinks.map(childLink => ({
    ...childLink,
    linkUrl: `${storeUrl}/${childLink.linkUrl}`
  }));
};

export default useLocalisedChildLinks;
